import styled from 'styled-components';

export const Input = styled.input<{ $optional?: boolean }>`
    width: 100%;
    border: 0;
    border-bottom: 1px solid ${({ theme }) => theme.border.dark};
    color: ${({ theme }) => theme.text.primary};

    height: ${({ theme }) => theme.scale.formInputHeight};
    padding: 4px 20px 0 8px;
    font-size: 1rem;
    &::placeholder {
        color: ${({ theme }) => theme.colors.cocoa400};
        font-style: ${({ $optional = false }) => ($optional ? 'italic' : 'none')};
    }

    &:disabled {
        background: ${({ theme }) => theme.intent.disabled};
        cursor: not-allowed;
    }
`;
